
import { test } from '@/services'
import { updateTheme, colorList } from '@/utils/theme'
import { Button } from 'ant-design-vue'

export default {
  name: 'About',
  components: {
    Button
  },
  data () {
    return {
      id: 0,
      fontSizeStep: 0,
      data: {},
      html: '',
      colorList: colorList
    }
  },
  methods: {
    changeColor (color) {
      updateTheme(color)
    },
    async test () {
      this.$message.success('123')
      try {
        const res = await test({
          name: 'admin',
          password: 'password'
        })
      } catch (e) {
        console.log(e)
      }
    }
  }
}
